<template>
  <div class="dialog">
    <div class="card">
      <h1>Upload CSV</h1>
      <form enctype="multipart/form-data">
        <input type="file" id="csv" v-on:change="$emit('upload-CSV', $event)" accept=".csv" />
        <label for="csv">
          <label class="label-button primary" for="csv">Choose A File</label>
        </label>
        <Button v-bind:title="'Cancel'" v-bind:type="'raised'" v-bind:colorTheme="'secondary'" v-on:button-click="$emit('hide-dialog')" />
      </form>
    </div>
  </div>
</template>

<script>
import Button from '@/components/form-elements/Button';

export default {
  name: 'UploadCSV',
  props: ['projectId'],
  components: { Button },
  data() {
    return {
      file: null
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../assets/styles/colors';
@import '../assets/styles/mixin';
@import '../assets/styles/input';
@import '../assets/styles/label-button';
@import '../assets/styles/dialog';
@import '../assets/styles/card';
</style>



// WEBPACK FOOTER //
// src/components/UploadCSV.vue